export const AUTH_DEFAULT_TITLE = 'Cutwise';
export const AUTH_DEFAULT_DESCRIPTION =
  'Access non-public diamond information, manage your lists, and explore options confidently. Anytime, on any device.';
